import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import * as OpenSeadragon from 'openseadragon';

@Component({
  selector: 'app-openseadragon-viewer',
  templateUrl: './openseadragon-viewer.component.html',
  styleUrls: ['./openseadragon-viewer.component.css'],
})
export class OpenseadragonViewerComponent implements OnChanges {
  @ViewChild('openseadragonContainer', { static: true }) container!: ElementRef;

  @Input() imagenes: string[] = []; // Array de URLs
  viewer: OpenSeadragon.Viewer | undefined;
  currentIndex: number = 0; // Índice de la imagen actual
  currentRotation: number = 0; // Rotación actual en grados

  ngOnChanges(changes: SimpleChanges): void {
   if (this.viewer != null) this.viewer.destroy();
   if (this.imagenes != null )  this.loadImages(); 
  }

  ngAfterViewInit(): void {
    this.initializeViewer();
  }

  initializeViewer(): void { 
  }

  loadImages(): void {
    this.viewer = OpenSeadragon({
      element: this.container.nativeElement,
      sequenceMode: true,
      showRotationControl: true,
      referenceStripScroll: 'vertical',
      prefixUrl: 'https://cdnjs.cloudflare.com/ajax/libs/openseadragon/4.0.0/images/', // Ruta de los controles
      tileSources: this.getTileSources(),
    });

    const tileSources = this.getTileSources();
    if (tileSources.length > 0 && this.viewer) {
      this.viewer.open(tileSources);
      this.currentRotation = 0; // Restablecer rotación al cargar una nueva imagen
    }
  }

  getTileSources(): any[] {
    // Convierte el array de URLs en un array de `tileSources`
    return this.imagenes.map((url) => (
      {
      type: 'image',
      url,
    }));
  }

  nextImage(): void {
    if (this.currentIndex < this.imagenes.length - 1) {
      this.currentIndex++;
      this.loadImages();
    }
  }

  previousImage(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.loadImages();
    }
  }

  rotateImage(): void {
    if (this.viewer) {
      this.currentRotation = (this.currentRotation + 90) % 360; // Incrementar rotación en 90 grados
      this.viewer.viewport.setRotation(this.currentRotation); // Aplicar rotación
    }
  }
}
